import service from '@/services/line-business/LineBusinessService'

export const lineBusinessModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    lineBusinessList: [],
  },
  mutations: {
    SET_LIST(state, payload) {
      state.lineBusinessList = payload.data ?? payload
    },
  },
  actions: {
    async getLinesBusiness({ commit }, payload) {
      let response = await service.getLinesBusiness(payload)
      commit('SET_LIST', response)
    }
  },
  getters: {
    getLineBusinessList: (state) => {
      return state.lineBusinessList
    },
  },
}
